import { render, staticRenderFns } from "./TransformNavigationMenu.vue?vue&type=template&id=106dcddb&scoped=true"
import script from "./TransformNavigationMenu.vue?vue&type=script&lang=ts"
export * from "./TransformNavigationMenu.vue?vue&type=script&lang=ts"
import style0 from "./TransformNavigationMenu.vue?vue&type=style&index=0&id=106dcddb&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106dcddb",
  null
  
)

export default component.exports